/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Search from "../../../Common/Search";
import Sorting from "../../../Common/Sorting";
import ConfirmEmailSend from "../../../Modals/send-email-cart-funnel";
import { connect } from "react-redux";
import {
  sortingCodeList,
  touchSourceValues,
} from "../../../../utilities/enums";
import { BiLoaderAlt } from "react-icons/bi";
import Paginations from "../../../Common/Pagination";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";
import { cartFunnelList } from "../../../../stores/actions/cart-funnel.actions.types";
import CartFunnelTable from "../../../Tables/CartFunnel";

const CartFunnelListPage = ({ cartFunnelList, loading }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [firstTouchSource, setFirstTouchSource] = useState("");
  const [lastTouchSource, setLastTouchSource] = useState("");
  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [cartFunnels, setCartFunnels] = useState([]);
  const [sorting, setSorting] = useState([
    {
      whom: "updatedAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    getCartFunnelList(search, pagination.page, sorting);
  }, [search, sorting, pagination.page, firstTouchSource, lastTouchSource]);

  const getCartFunnelList = (q = "", page, sort) => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, cardFunnels } = data?.data;
        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));
        setCartFunnels(cardFunnels);
      }
    };

    let request = {
      callback,
      data: { q, page, sort, firstTouchSource, lastTouchSource },
    };
    cartFunnelList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  return (
    <div>
      <MetaHead title={t("cart-funnel-list")} />
      <div className='flex flex-col sm:flex-row justify-end mb-3 gap-2'>
        <Search
          placeholder='Cart Funnel Name'
          search={search}
          setSearch={setSearch}
        />
        <Sorting
          name={"First Touch Source"}
          values={touchSourceValues}
          onChange={setFirstTouchSource}
        />
        <Sorting
          name={"Last Touch Source"}
          values={touchSourceValues}
          onChange={setLastTouchSource}
        />
        <Sorting
          name={"Sort"}
          values={sortingCodeList}
          onChange={handleChangeSorting}
        />
        <ConfirmEmailSend />
      </div>

      {loading ? (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : cartFunnels?.length ? (
        <CartFunnelTable
          cartFunnels={cartFunnels}
          setCartFunnels={setCartFunnels}
        />
      ) : (
        <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          Not found
        </div>
      )}

      <Paginations pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  cartFunnelList,
})(CartFunnelListPage);
